import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteACoupon,
  getAllCoupon,
  resetState,
} from "../features/coupon/couponSlice";
import CustomModal from "../components/CustomModal";

const Couponlist = () => {
  const [open, setOpen] = useState(false);
  const [couponId, setCouponId] = useState("");

  const dispatch = useDispatch();
  const couponState = useSelector((state) => state.coupon.coupons) || [];

  useEffect(() => {
    dispatch(resetState());
    dispatch(getAllCoupon());
  }, [dispatch]);

  const showModal = (id) => {
    setOpen(true);
    setCouponId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const deleteCoupon = (id) => {
    dispatch(deleteACoupon(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getAllCoupon());
    }, 100);
  };

  const data1 = couponState.map((coupon, index) => ({
    key: index + 1,
    name: coupon.code || "N/A",
    discount: coupon.discountValue || 0,
    minOrderAmount: coupon.minOrderAmount || 0,
    maxDiscount: coupon.maxDiscountAmount || 0,
    usageLimit: coupon.usageLimit || "N/A",
    perUserLimit: coupon.perUserLimit || "N/A",
    isActive: coupon.isActive ? "Active" : "Inactive",
    expiry: coupon.expiryDate
      ? new Date(coupon.expiryDate).toLocaleDateString()
      : "N/A",
    action: (
      <>
        <Link
          to={`/admin/coupon/${coupon._id}`}
          className="fs-3 text-danger"
        >
          <BiEdit />
        </Link>
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => showModal(coupon._id)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  }));

  const columns = [
    {
      title: "SNo",
      dataIndex: "key",
    },
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Discount",
      dataIndex: "discount",
      sorter: (a, b) => a.discount - b.discount,
    },
    {
      title: "Min Order Amount",
      dataIndex: "minOrderAmount"
    },
    {
      title: "Max Discount Amount",
      dataIndex: "maxDiscount"
    },
    {
      title: "Usage Limit",
      dataIndex: "usageLimit"
    },
    {
      title: "Per User Limit",
      dataIndex: "perUserLimit"
    },
    {
      title: "Status",
      dataIndex: "isActive"
    },
    {
      title: "Expiry",
      dataIndex: "expiry",
      sorter: (a, b) =>
        new Date(a.expiry).getTime() - new Date(b.expiry).getTime(),
    },
    {
      title: "Action",
      dataIndex: "action",
    },
  ];

  return (
    <div>
      <h3 className="mb-4 title">Coupons</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => deleteCoupon(couponId)}
        title="Are you sure you want to delete this Coupon?"
      />
    </div>
  );
};

export default Couponlist;
